import React from "react";
import { Suspense } from "react";
import ReactDOM from "react-dom";

export const renderLazyComponent = (children, elementNode) => {
    return ReactDOM.render(<Suspense fallback={<div>Loading...</div>}>{children}</Suspense>, elementNode);
  };